(ns ballot-scout-v2-frontend.import-manager.views
  (:require
   [ballot-scout-v2-frontend.components.breadcrumb-navigator :refer [navigator]]
   [ballot-scout-v2-frontend.components.field-matcher :as fm]
   [ballot-scout-v2-frontend.components.icon :refer [icon] :as icon]
   [ballot-scout-v2-frontend.components.link :refer [link]]
   [ballot-scout-v2-frontend.components.pagination :refer [pagination]]
   [ballot-scout-v2-frontend.components.upload :refer [upload-file]]
   [ballot-scout-v2-frontend.events :as events]
   [ballot-scout-v2-frontend.import-manager.common :refer [default-search-state]]
   [ballot-scout-v2-frontend.import-manager.events :as e.import]
   [ballot-scout-v2-frontend.import-manager.subs :as s.import]
   [ballot-scout-v2-frontend.request-helpers :as request-helpers]
   [ballot-scout-v2-frontend.resources.subs :as s.resources]
   [ballot-scout-v2-frontend.subs :as subs]
   [ballot-scout-v2-frontend.util :as util :refer [remove-empty-values]]
   [clojure.string :as str]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn upload-stage []
  [upload-file
   (rf/subscribe [::s.import/upload])
   #(rf/dispatch [::e.import/upload
                  (:jurisdiction/id @(rf/subscribe [::subs/current-jurisdiction]))
                  @(rf/subscribe [::subs/current-election-slug])
                  %])
   [:ul
    [:li "The file must be formatted as .csv or .txt"]
    [:li "The file must contain a header row of field names"]
    [:li "The file should not contain duplicate records"]]])

(defn import-uploader []
  (let [import-guide (:import-guide @(rf/subscribe [::s.resources/resource-urls]))]
    [:div {:class (str "import-uploader")}
     [:div {:class "level"}
      [:div {:class "level-left"}
       [:h1 {:class "heading-1"} "New Voter Import"]]
      [:div {:class "level-right"}
       [navigator @(rf/subscribe [::s.import/current-import-phases]) :import-phase/upload-file]]]
     [:div {:class "columns pb-6"}
      [:div {:class "column"}
       [:span {:class "has-text-weight-bold"}
        "Locate your voter file and upload it to Ballot Scout"]
       (when import-guide
         [:div {:class "pt-4"}
          "To review the import user guide, please "
          [:a {:href import-guide :target "_blank"} "click here"]])]]
     [:div {:class "columns"}
      [:div {:class "column"}
       [upload-stage]]]]))

(defn create-page []
  (let [current-jurisdiction-slug @(rf/subscribe [::subs/current-jurisdiction-slug])
        current-jurisdiction @(rf/subscribe [::subs/current-jurisdiction])
        current-election @(rf/subscribe [::subs/current-election])]
    (if (and current-jurisdiction current-election)
      [:div.import-manager
       [import-uploader]]
      (if-let [fetch-error (or @(rf/subscribe [::request-helpers/failed-request
                                               [::events/fetch-jurisdiction current-jurisdiction-slug]])
                               @(rf/subscribe [::request-helpers/failed-request
                                               [::events/fetch-elections-for-jurisdiction current-jurisdiction-slug]]))]
        (:status-text fetch-error)
        [:div.loading
         [:img.centered-img {:src "/images/compass-100x100.png"}]]))))

(defn import-title [import]
  (cond (:import/completed-ts import)
        "Import Completed"
        (:import/started-ts import)
        "Import In Progress"
        (= "terminated-due-to-invalid-rows" (:import/phase import))
        "Errors Found"
        :else
        "Import Pending"))

(defn download-link [url]
  [:a {:href url :download "export.csv" :target "_blank"}
   [:strong "Download"]])

(defn import-summary
  [{:import/keys [id
                  voters-to-import-count invalid-rows-count imported-ballots-count
                  created-ts started-ts completed-ts
                  original-file-url derived-file-url voter-labels-file-url invalid-rows-file-url
                  phase
                  should-generate-ob-imbs should-generate-vb-imbs should-generate-labels should-reissue-all-ballots
                  external-ids-to-reissue
                  uploaded-by started-by]
    :as import}
   title?]
  [:div
   (when title?
     [link {:route-name :ballot-scout-v2-frontend.routes/import-manager
            :params {:partner-slug @(rf/subscribe [::subs/current-partner-slug])
                     :jurisdiction-slug @(rf/subscribe [::subs/current-jurisdiction-slug])
                     :election-slug @(rf/subscribe [::subs/current-election-slug])
                     :import-id id}}
      [:h4 {:class "heading-4"}
       (import-title import)
       " "
       [:button {:class "button is-clickable is-small"}
        "View Import"]]])

   [:div
    (when voters-to-import-count
      [:div {:class "pt-3"}
       (cond
         completed-ts
         [:div "Number of voters imported: "
          [:strong imported-ballots-count]]

         started-ts
         [:div "Number of voters imported: "
          [:strong imported-ballots-count " / " voters-to-import-count]]

         :else
         [:div "Number of voters to import: "
          [:strong voters-to-import-count]])
       (when (not title?)
         [:<>
          (when completed-ts
            [:div "CSV mail file: " [download-link derived-file-url]])
          (when voter-labels-file-url
            [:div "Mailing labels: " [download-link voter-labels-file-url]])])])

    (when (and (not (#{"column-mapping" "imb-generation" "terminated-due-to-invalid-rows"} phase))
               (not title?))
      [:div {:class "pt-3"}
       [:div "IMb(s) created: "
        [:strong
         (cond (not (or should-generate-ob-imbs should-generate-vb-imbs))
               "None"

               (and should-generate-ob-imbs should-generate-vb-imbs)
               "Voter-bound and Office-bound"

               should-generate-vb-imbs
               "Voter-bound"

               should-generate-ob-imbs
               "Office-bound")]]
       (when (some? should-generate-labels)
         [:div "Label generation: "
          [:strong (if should-generate-labels
                     "Yes"
                     "No")]])
       (when voters-to-import-count
         (let [external-ids external-ids-to-reissue
               external-ids-csv (str/join ", " external-ids)]
           [:div "Re-issue ballots for: "
            [:strong
             (cond should-reissue-all-ballots
                   "All"

                   (str/blank? external-ids-csv)
                   "None"

                   :else
                   (str (count external-ids) " voter(s) with the following external IDs: " external-ids-csv))]]))])

    (when (not title?)
      [:div {:class "pt-3"}
       [:div "Total rows in original file: "
        [:strong
         (get import :import/rows-count 0)]]
       (when invalid-rows-count
         [:div "Total invalid rows: "
          [:strong invalid-rows-count]])
       (when original-file-url
         [:div "Original file: " [download-link original-file-url]])
       (when invalid-rows-file-url
         [:div "Invalid rows file: " [download-link invalid-rows-file-url]])])

    [:div {:class "pt-3"}
     (cond
       completed-ts
       [:div "Completed at: " [:strong (util/render-datetime completed-ts)]
        (when started-by
          [:span " by " [:strong started-by]])]
       started-ts
       [:div "Import initiated at: "
        [:strong (util/render-datetime started-ts)]
        (when started-by
          [:span " by " [:strong started-by]])]
       created-ts
       [:div "Created at: "
        [:strong (util/render-datetime created-ts)]
        (when uploaded-by
          [:span " by " [:strong uploaded-by]])])]

    (when completed-ts
      [:div {:class "pt-3"}
       [link {:route-name :ballot-scout-v2-frontend.routes/jurisdiction-voter-lookup
              :params {:partner-slug @(rf/subscribe [::subs/current-partner-slug])
                       :jurisdiction-slug @(rf/subscribe [::subs/current-jurisdiction-slug])
                       :election-slug @(rf/subscribe [::subs/current-election-slug])}
              :query {:import-id id}}
        [:span {:class "has-text-weight-bold"}
         "View the imported ballots"]]])]])

(def standard-fields [{:text "First Name"   :name :firstname   :required #(not (contains? % :fullname))}
                      {:text "Middle Name"  :name :middlename  :required (constantly false)}
                      {:text "Last Name"    :name :lastname    :required #(not (contains? % :fullname))}
                      {:text "Full Name"    :name :fullname    :required (constantly false)}
                      {:text "Suffix"       :name :suffix      :required (constantly false)}
                      {:text "Address 1"    :name :address-1   :required (constantly true)}
                      {:text "Address 2"    :name :address-2   :required (constantly false)}
                      {:text "City"         :name :city        :required (constantly true)}
                      {:text "State"        :name :state       :required (constantly true)}
                      {:text "Zip Code"     :name :zip         :required (constantly true)}
                      {:text "External ID"  :name :external-id :required (constantly true)}
                      {:text "Date of Birth"
                       :name :date-of-birth :required (constantly false)}
                      {:text "Year of Birth"
                       :name :year-of-birth :required (constantly false)}
                      {:text "Numeric Voter-bound IM Barcode"
                       :name :voter-bound-imb  :required (constantly false)}
                      {:text "Numeric Partner-bound IM Barcode"
                       :name :office-bound-imb :required (constantly false)}
                      {:text "Precinct"     :name :precinct    :required (constantly false)}])

(def standard-fields-by-text (zipmap (map :text standard-fields) standard-fields))

(defn field-matcher [headers]
  (let [setting-column-mapping?
        (= :setting-column-mapping (get-in @(rf/subscribe [::s.import/import-data]) [:header-state :status]))
        submit-mapping-fn
        (fn [header-mapping]
          (rf/dispatch [::e.import/post-column-mapping
                        @(rf/subscribe [::subs/current-import])
                        header-mapping]))]
    [:div
     [:div {:class "has-text-weight-bold"}
      "Please map the columns in your file to Ballot Scout's fields"]
     [:div {:class "content"}
      [:ul
       [:li "If there is a field you will not be importing or that is not an existing Ballot Scout field, please map it to \"do not import\""]
       [:li "The Ballot Scout field \"External ID\" should be mapped to the field in your file for Voter ID"]
       [:li "Once you have mapped all of your fields, please click \"Confirm Headers\""]]]
     [fm/field-matcher standard-fields headers setting-column-mapping? submit-mapping-fn]
     [:hr]
     [:div {:class "columns"}
      [:div {:class "column is-12"}
       [import-summary @(rf/subscribe [::subs/current-import])]]]]))

(defn field-matcher-section []
  (when-let [headers (not-empty @(rf/subscribe [::s.import/headers]))]
    [field-matcher headers]))

(defn reissue-td [{:keys [reissue? on-change key]}]
  [:td {:key key}
   [:div {:class "control"}
    [:label {:class "radio"}
     [:input {:type "radio"
              :name (str "skip-or-reissue-" key)
              :on-change #(on-change :skip)
              :checked (not reissue?)}]
     " Skip"]]
   [:div {:class "control"}
    [:label {:class "radio"}
     [:input {:type "radio"
              :name (str "skip-or-reissue-" key)
              :on-change #(on-change :reissue)
              :checked reissue?}]
     " Re-issue"]]])

(defn reissue-ballots-table
  "Component for individually configuring whether to reissue ballots for each existing voter"
  [{:keys [voters-to-reissue should-reissue-all-ballots?]}]
  (let [{:keys [rows header-row]} @(rf/subscribe [::s.import/existing-voters-state])
        standard-field-indexes (into {} (map-indexed #(vector %2 %1) standard-fields))
        standard-fields-text-set (->> standard-fields (map :text) (into #{}))

        headers (->> header-row
                     (sort-by (comp standard-field-indexes standard-fields-by-text))
                     (filter #(contains? standard-fields-text-set %))
                     vec)
        headers (concat ["Skip or Re-issue ballots?"] headers)
        _ @voters-to-reissue]
    [:div {:class "reissue-table-container"}
     [:table {:class "table reissue-table"}
      [:thead
       [:tr (for [h headers]
              [:td {:key (str "hdr-" h)} h])]]
      [:tbody
       (for [row rows]
         (let [k (str "row-" (first row))
               external-id (get row "External ID")]
           [:tr {:key k}
            [reissue-td {:key (str "reissue-td-" external-id)
                         :reissue? (contains? @voters-to-reissue external-id)
                         :on-change #(do (reset! should-reissue-all-ballots? false)
                                         (if (= :skip %)
                                           (swap! voters-to-reissue disj external-id)
                                           (swap! voters-to-reissue conj external-id)))}]
            (for [h (rest headers)]
              [:td {:key (str k "-" h)}
               (get row h)])]))]]]))

(defn mailer-info [mlr-config]
  [:div
   [:div "Mailer ID: " [:strong (:mailer-config/usps-mailer-id mlr-config)]]
   [:div "Destination STID: " [:strong (:mailer-config/destination-stid mlr-config)]]
   [:div "Origin STID: " [:strong (:mailer-config/origin-stid mlr-config)]]])

(defn generate-imbs-section []
  (let [import (rf/subscribe [::subs/current-import])
        partner (rf/subscribe [::subs/current-partner])
        jurisdiction (rf/subscribe [::subs/current-jurisdiction])
        generate-vb-imbs? (r/atom false)
        generate-ob-imbs? (r/atom false)
        generate-labels? (r/atom false)

        post-imb-generation!
        #(rf/dispatch [::e.import/post-imb-generation
                       @import
                       {:mailer-config-id (:partner/default-mailer-config-id @partner)
                        :generate-vb-imbs? @generate-vb-imbs?
                        :generate-ob-imbs? @generate-ob-imbs?
                        :generate-labels? @generate-labels?}])]
    (fn []
      (let [default-mlr-config (:partner/default-mailer-config @partner)
            address (or (not-empty (:jurisdiction/address @jurisdiction))
                        (not-empty (:partner/address @partner)))
            vb-generation-issues
            (when (str/blank? (:mailer-config/destination-stid default-mlr-config))
              "No destination STID set in mailer config")
            ob-generation-issues
            (cond-> []
              (str/blank? (:mailer-config/origin-stid default-mlr-config))
              (conj "No origin STID set in mailer config")

              (str/blank? (or (:address/routing-code address)
                              (:address/zip address)))
              (conj "No routing code set on jurisdiction or partner"))

            setting? (= :setting (get-in @(rf/subscribe [::s.import/import-data])
                                         [:imb-generation-state :status]))
            warning-class "has-background-warning has-text-black px-2 py-1"]
        [:div
         [:div {:class "has-text-weight-bold"}
          "Intelligent Mail barcode (IMb) Creation Settings"]
         [:div {:class "content"}
          [:ul
           [:li "Please select which IMbs you will need created and if you’ll need Ballot Scout to create a PDF of mailing labels"]
           [:li "If you have imported your own IMbs, please do not check any boxes and simply click \"Confirm IMb settings\""]]]

         [:div {:class "columns"}
          [:div {:class "column is-12"}
           (if default-mlr-config
             [:div {:class "has-text-weight-semibold pb-3"}
              "Select which IMbs should be created during this import"]
             [:div {:class "has-text-weight-semibold pb-3"}
              [:span "Partner does not have their mailer set up. "]
              [:span
               [:a {:href "#" :on-click post-imb-generation!}
                [:strong "Continue without generating IMbs"]]]])
           [:div
            [:div
             [:label {:class "checkbox" :disabled (some? vb-generation-issues)}
              [:input {:type "checkbox" :name "generate-vb-imbs"
                       :disabled (some? vb-generation-issues)
                       :on-change #(swap! generate-vb-imbs? not)
                       :value @generate-vb-imbs?}]
              " Create IMbs to the voter "
              (when vb-generation-issues
                [:span {:class warning-class}
                 [:span {:class "icon is-small"}
                  [icon ::icon/exclamation-triangle]]
                 " "
                 vb-generation-issues])]]
            [:div {:class "pb-3"}
             [:label {:class "checkbox" :disabled (not-empty ob-generation-issues)}
              [:input {:type "checkbox" :name "generate-ob-imbs"
                       :disabled (not-empty ob-generation-issues)
                       :on-change #(swap! generate-ob-imbs? not)
                       :value @generate-ob-imbs?}]
              " Create IMbs to the office "
              (when (not-empty ob-generation-issues)
                [:span {:class warning-class}
                 [:span {:class "icon is-small"}
                  [icon ::icon/exclamation-triangle]]
                 " "
                 (str/join ", " ob-generation-issues)])]]

            [:div {:class "columns"}
             [:div {:class "column is-12"}
              [:div {:class "has-text-weight-semibold pb-3"}
               "Check the box below if you will need a PDF of mailing labels at the end of this import"]
              [:div
               [:label {:class "checkbox"}
                [:input {:type "checkbox" :name "generate-labels"
                         :on-change #(swap! generate-labels? not)
                         :value @generate-labels?}]
                " Create mailing labels"]]]]

            (when default-mlr-config
              [:div {:class "columns"}
               [:div {:class "column"}
                [:div {:class "has-text-weight-semibold pb-3"}
                 "IMb information"]
                [mailer-info default-mlr-config]]])]]]

         (when default-mlr-config
           [:div {:class "columns"}
            [:div {:class "column is-12"}
             [:button {:class "button is-primary"
                       :disabled setting?
                       :on-click post-imb-generation!}
              [:span "Confirm IMb settings"]
              [:span {:class "icon is-small"}
               [icon (if setting? ::icon/spinner ::icon/chevron-right)
                {:pulse? setting?}]]]]])

         [:hr]
         [:div {:class "columns"}
          [:div {:class "column is-12"}
           [import-summary @import]]]]))))

(def MAX_VOTERS_FOR_SELECTOR 100)

(defn reissue-ballots-section []
  (let [import (rf/subscribe [::subs/current-import])
        existing-voters-count (:import/existing-voters-count @import)
        reissue-ballots-table-enabled? (<= existing-voters-count MAX_VOTERS_FOR_SELECTOR)
        voters-to-reissue (r/atom #{})
        should-reissue-all-ballots? (r/atom false)
        post-reissue-ballot-config!
        #(rf/dispatch [::e.import/post-reissue-ballot-config
                       @import
                       {:should-reissue-all-ballots? @should-reissue-all-ballots?
                        :voters-to-reissue @voters-to-reissue}])]
    (fn []
      (let [reissue-status
            (cond (or @should-reissue-all-ballots?
                      (= existing-voters-count (count @voters-to-reissue)))
                  :all
                  (empty? @voters-to-reissue)
                  :none
                  :else
                  :some)
            setting? (= :setting-reissue-ballot-config
                        (get-in @(rf/subscribe [::s.import/import-data])
                                [:existing-voters-state :status]))]
        [:div
         [:div {:class "has-text-weight-bold pb-3"}
          (if (pos? existing-voters-count)
            "Specify which ballots to re-issue"
            "No ballots to re-issue")]

         (if (pos? existing-voters-count)
           [:div
            "Ballot Scout identified "
            [:span {:class "has-text-weight-bold"} existing-voters-count]
            " existing voter(s). Please proceed with one of the options below and then click \"Continue\""]
           [:div {:class "pb-3"} "Your import file does not contain any records already in the system!"])

         (if (pos? existing-voters-count)
           [:div
            [:div {:class "content"}
             [:ul
              [:li "Select \"Skip All\" to skip importing all of these records"]
              [:li "Select \"Re-issue All\" to import all of these records"]
              (if reissue-ballots-table-enabled?
                [:li "Use the ballot selector below to select individual ballots to skip or re-issue"]
                [:li "View the existing records by downloading "
                 [:a {:href (:import/existing-voters-file-url @import)
                      :download "export.csv"
                      :target "_blank"}
                  [:strong " this file"]]])]
             [:div {:class "buttons"}
              [:button {:class (str "button" (when (= :none reissue-status) " is-success"))
                        :on-click
                        #(do (reset! should-reissue-all-ballots? false)
                             (when reissue-ballots-table-enabled?
                               (reset! voters-to-reissue #{})))}
               (when (= :none reissue-status)
                 [:span {:class "icon"}
                  [icon ::icon/check]])

               [:span "Skip All"]]
              [:button {:class (str "button" (when (= :all reissue-status) " is-success"))
                        :on-click
                        #(do (reset! should-reissue-all-ballots? true)
                             (when reissue-ballots-table-enabled?
                               (let [external-ids (->> @(rf/subscribe [::s.import/existing-voters-state])
                                                       :rows
                                                       (map (fn [row] (get row "External ID")))
                                                       (into #{}))]
                                 (reset! voters-to-reissue external-ids))))}
               (when (= :all reissue-status)
                 [:span {:class "icon"}
                  [icon ::icon/check]])
               [:span "Re-issue All"]]
              [:button {:class "button is-primary"
                        :disabled setting?
                        :on-click post-reissue-ballot-config!}
               [:span "Continue"]
               [:span {:class "icon is-small"}
                [icon (if setting? ::icon/spinner ::icon/chevron-right)
                 {:pulse? setting?}]]]]

             (if reissue-ballots-table-enabled?
               [reissue-ballots-table {:voters-to-reissue voters-to-reissue
                                       :should-reissue-all-ballots? should-reissue-all-ballots?}]
               [:div
                "More than "
                [:strong MAX_VOTERS_FOR_SELECTOR]
                " existing voters found. Ballot selector has been disabled. To see which existing voters were identified, download "
                [:a {:href (:import/existing-voters-file-url @import)
                     :download "export.csv"
                     :target "_blank"}
                 [:strong " this file"]]])]]
           [:div
            [:div {:class "content"}
             [:button {:class "button is-primary"
                       :on-click post-reissue-ballot-config!}
              [:span "Continue"]
              [:span {:class "icon is-small"}
               [icon ::icon/chevron-right]]]]])
         [:hr]
         [:div {:class "columns"}
          [:div {:class "column is-12"}
           [import-summary @import]]]]))))

(defn final-phase-section []
  (let [import @(rf/subscribe [::subs/current-import])
        start-button? (not (or (:import/started-ts import)
                               (:import/completed-ts import)))]
    (when-not (#{"ready-to-start" "completed"} (:import/phase import))
      (rf/dispatch [::e.import/poll-for-completed-import]))
    [:div
     [:div {:class "level"}
      [:div {:class "level-left"}
       [:span {:class "has-text-weight-bold"}
        (cond
          (:import/completed-ts import)
          "Import has completed successfully!"
          (= (:import/phase import) "generating-labels")
          [:<>
           [:div "Generating labels for this import"]
           [:div "Keep an eye on this page for status updates"]]
          (:import/started-ts import)
          [:<>
           [:div "This import is currently in progress"]
           [:div "Keep an eye on this page for status updates"]]
          :else
          "Please review the import below before clicking \"Start Import\".")]]]

     [:div {:class "columns"}
      [:div {:class "column is-12"}
       [import-summary import]]]

     (when start-button?
       [:div {:class "columns"}
        [:div {:class "column is-12"}
         [:button {:class "button is-primary is-large"
                   :on-click #(rf/dispatch [::e.import/start-import import])}
          [:span "Start Import "]
          [:span {:class "icon"} [icon ::icon/upload]]]]])

     (when (or
            (= (:import/phase import) "generating-labels")
            (and (:import/started-ts import) (not (:import/completed-ts import))))
       [:div.loading {:class "column is-12"}
        [:img.centered-img {:class "p-6" :src "/images/compass-100x100.png"}]])]))

(defn invalid-rows-table
  "Component for individually configuring whether to reissue ballots for each existing voter"
  []
  (let [{:keys [rows header-row]} @(rf/subscribe [::s.import/invalid-rows-state])]
    [:div.invalid-rows-container
     [:table.table.invalid-rows-table
      [:thead
       [:tr (for [h header-row]
              [:td {:key (str "hdr-" h)} h])]]
      [:tbody
       (for [row rows]
         (let [k (str "row-" (first row))]
           [:tr {:key k}
            (for [h header-row]
              [:td {:key (str k "-" h)}
               (get row h)])]))]]]))

(defn restart-import-li []
  [:li "In order to proceed, please correct the errors in your original file and then "
   [link {:route-name :ballot-scout-v2-frontend.routes/create-import
          :params {:partner-slug @(rf/subscribe [::subs/current-partner-slug])
                   :jurisdiction-slug @(rf/subscribe [::subs/current-jurisdiction-slug])
                   :election-slug @(rf/subscribe [::subs/current-election-slug])}}
    [:span {:class "has-text-weight-bold"}
     "start a new import"]]])

(defn invalid-rows-section []
  (let [import @(rf/subscribe [::subs/current-import])
        invalid-rows-count (:import/invalid-rows-count import)
        show-table? (<= invalid-rows-count MAX_VOTERS_FOR_SELECTOR)]
    [:div
     [:div {:class "columns"}
      [:div {:class "column is-6"}
       [:div {:class "notification is-danger is-light"}
        [:h3 {:class "has-text-weight-bold"}
         [:span {:class "icon"}
          [icon ::icon/exclamation-triangle]]
         [:span "Your file contains " invalid-rows-count " invalid rows"]]]]]
     [:div {:class "content"}
      [:ul
       (when-not show-table?
         [:li "We've created a file with details of the errors we found in your file. "
          [:a {:href (:import/invalid-rows-file-url import)
               :download "invalid-rows.csv" :target "_blank"}
           [:span "Download a file with the invalid rows"]]])
       [restart-import-li]
       (when show-table?
         [:li "For reference, we're displaying the errors below. (You can also "
          [:a {:href (:import/invalid-rows-file-url import)
               :download "invalid-rows.csv" :target "_blank"}
           [:span "download a file with the invalid rows."]]
          ")"])]]

     [:div {:class "columns"}
      [:div {:class "column is-12"}
       (when show-table?
         [invalid-rows-table])]]
     [:hr]
     [:div {:class "columns"}
      [:div {:class "column is-12"}
       [import-summary import]]]]))

(defn manager []
  (let [fetch-status @(rf/subscribe [::s.import/fetch-import-status])
        import @(rf/subscribe [::subs/current-import])
        phase (e.import/phase-mappings (:import/phase import))]

    (case fetch-status
      :errored [:h1 {:class "heading-1"} "Could not load import."]
      :fetching [:div
                 [:div
                  [:h1 {:class "heading-1"} "Voter Import Details"]]
                 [:div.loading
                  [:img {:class "p-2 centered-img" :src "/images/compass-100x100.png"}]]]
      [:div
       [:div {:class "level"}
        [:div {:class "level-left"}
         [:h1 {:class "heading-1"}
          (import-title import)]]
        [:div {:class "level-right"}
         [navigator @(rf/subscribe [::s.import/current-import-phases]) phase]]]
       (case phase
         :import-phase/match-fields [field-matcher-section]
         :import-phase/invalid-rows [invalid-rows-section]
         :import-phase/generate-imbs [generate-imbs-section]
         :import-phase/reissue-ballots [reissue-ballots-section]
         :import-phase/final [final-phase-section])])))

(defn manager-page []
  (if-let [_current-import @(rf/subscribe [::subs/current-import])]
    [:div {:class "import-manager"}
     [manager]]
    (if-let [fetch-error @(rf/subscribe [::request-helpers/failed-request
                                         ::e.import/fetch-import
                                         @(rf/subscribe [::subs/current-import-id])])]
      (:status-text fetch-error)
      [:div.loading
       [:img.centered-img {:style {:padding "2em"} :src "/images/compass-100x100.png"}]])))

(defn- change-imports-list-page!
  [new-pagination-state]
  (let [new-state (remove-empty-values new-pagination-state)]
    (rf/dispatch [:ballot-scout-v2-frontend.routes/navigate
                  :ballot-scout-v2-frontend.routes/import-list
                  {:partner-slug @(rf/subscribe [::subs/current-partner-slug])
                   :jurisdiction-slug @(rf/subscribe [::subs/current-jurisdiction-slug])
                   :election-slug @(rf/subscribe [::subs/current-election-slug])}
                  new-state])))

(defn list-view [{:keys [results total-pages] :or {results [] total-pages 0}}]
  (let [imports (filter #(e.import/phase-mappings (:import/phase %)) results)
        url-state (rf/subscribe [::subs/query-params])]
    (if (empty? imports)
      "No voter imports have been created yet."
      [:div
       [:div {:class "mb-6"}
        (for [import imports]
          [:div {:class "columns"}
           [:div {:class "column is-12"}
            [import-summary import true]
            [:hr]]])]
       [pagination {:curr-page (:page (merge default-search-state @url-state))
                    :total-pages total-pages
                    :on-page #(change-imports-list-page! (assoc @url-state :page %))}]])))

(defn list-page []
  [:div {:class "import-list"}
   [:div {:class "level"}
    [:div {:class "level-left"}
     [:h1 {:class "heading-1"} "Past Voter Imports"]]
    [:div {:class "level-right"}
     [link {:route-name :ballot-scout-v2-frontend.routes/create-import
            :params {:partner-slug @(rf/subscribe [::subs/current-partner-slug])
                     :jurisdiction-slug @(rf/subscribe [::subs/current-jurisdiction-slug])
                     :election-slug @(rf/subscribe [::subs/current-election-slug])}}
      [:button {:class "button"} "New Voter Import"]]]]
   (let [{:keys [status data error-response]} @(rf/subscribe [::s.import/imports-list-state])]
     (case status
       :success [list-view data]
       :errored [:div error-response]
       ;default - fetching
       [:div.loading
        [:img.centered-img {:src "/images/compass-100x100.png"}]]))])
